module.exports = __webpack_public_path__ + "img/video706.5799875d.jpg";